<template>
  <aside class="sidebar">
    <div class="sidebar-section">
      <h3 class="sidebar-title">Workflow</h3>
      <div class="workflow-stages">
        <div
          v-for="{ stage, label, number } in WORKFLOW_STAGES"
          :key="stage"
          :class="['stage-item', getStageStatus(stage)]"
          @click="store.stageSelectNav(stage)"
        >
          <div :class="['stage-icon', getStageStatus(stage)]">
            {{ getStageIcon(stage, number) }}
          </div>
          <span>{{ label }}</span>
        </div>
      </div>
    </div>

    <div class="sidebar-section">
      <h3 class="sidebar-title">Recent</h3>
      <div class="text-center" style="color: #9ca3af; font-size: 14px">No recent templates</div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WorkflowStage } from '../../types'
import { getCompletedStages, getSkippedStages } from '../../utils/workflow'
import { useWorkflowStore } from '../../stores/workflow'

const store = useWorkflowStore()

interface StageInfo {
  stage: WorkflowStage
  label: string
  number: number
}

const WORKFLOW_STAGES: StageInfo[] = [
  { stage: WorkflowStage.UPLOAD, label: 'Upload Template', number: 1 },
  { stage: WorkflowStage.MOBILE, label: 'Mobile Wizard', number: 2 },
  { stage: WorkflowStage.STAMPZ, label: 'Stampz & SHLink', number: 3 },
  { stage: WorkflowStage.REGISTER, label: 'URL Registration', number: 4 },
  { stage: WorkflowStage.STICKERS, label: 'eRx Stickers', number: 5 },
  { stage: WorkflowStage.MAPPING, label: 'FHIR Mapping', number: 6 },
  { stage: WorkflowStage.FIELDS, label: 'Field Assignment', number: 7 },
  { stage: WorkflowStage.REVIEW, label: 'Review', number: 8 },
  { stage: WorkflowStage.EXPORT, label: 'Export', number: 9 },
]

const completedStages = computed(() => getCompletedStages(store.workflowStages))
const skippedStages = computed(() => getSkippedStages(store.workflowStages))

function getStageStatus(stage: WorkflowStage): string {
  const isActive = stage === store.currentStage
  if (completedStages.value.includes(stage)) return isActive ? 'active completed' : 'completed'
  if (skippedStages.value.includes(stage)) return isActive ? 'active skipped' : 'skipped'
  if (isActive) return 'active'
  return 'pending'
}

function getStageIcon(stage: WorkflowStage, number: number): string {
  if (completedStages.value.includes(stage)) return '\u2713'
  if (skippedStages.value.includes(stage)) return '\u2298'
  return number.toString()
}
</script>
